<template>
  <div>
    <el-row style="margin-top: 20px; padding-left: 5px">
      <el-row>
        <el-col :sm="16">
          <div style="display: inline-block; margin-right: 10px">
            <span style="font-weight: 700">Chọn thời gian</span> <br>
            <el-select id="select-month" size="small" value="" placeholder="Chọn tháng" v-model="month" filterable
                       @change="m__generate_data" :disabled="loading.get_data">
              <el-option v-for="item of months" :key="item" :value="item" :label="`Tháng ${item + 1}`"></el-option>
            </el-select>&nbsp;&nbsp;
            <el-select size="small" value="" placeholder="Chọn năm" v-model="year" filterable @change="m__generate_data"
                       :disabled="loading.get_data">
              <el-option v-for="item of years" :key="item" :value="item" :label="item"></el-option>
            </el-select>
          </div>
          <div style="display: inline-block; margin-right: 10px">
            <span style="font-weight: 700">Loại đơn hàng</span> <br>
            <el-select value="" size="small" v-model="order_type">
              <el-option :value="''" label="Tất Cả Đơn"></el-option>
              <el-option :value="'confirmed'" :label="$t('center.confirmed_order')"></el-option>
              <el-option :value="'paid'" :label="$t('center.paid_order')"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :sm="4" style="padding-right: 10px">
          <span style="font-weight: 700">&nbsp;</span> <br>
          <el-input size="small" v-model="search" :placeholder="$t('input.placeholder')"
                    suffix-icon="el-icon-search" clearable></el-input>
        </el-col>
        <el-col :sm="4">
          <span style="font-weight: 700">&nbsp;</span> <br>
          <el-select size="small" value="" class="full-w" v-model="completable">
            <el-option value="" label="Khả năng hoàn thành"></el-option>
            <el-option value="complete" label="Có khả năng hoàn thành"></el-option>
            <el-option value="not_complete" label="Không có khả năng hoàn thành"></el-option>
          </el-select>
        </el-col>

      </el-row>

      <el-row style="margin-top: 40px">
        <el-col :sm="20">
          <strong style="font-size: 14px" class="text-warning">
            Số shop dự kiến không đạt: {{ m__get_not_complete() | format_currency }}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong style="font-size: 14px" class="text-success">
            Đã đạt kế hoạch: {{ m__get_complete() | format_currency }}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong style="font-size: 14px" class="text-danger">
            Đã dùng hết chi phí Ads: {{ m__get_out_of_cost() | format_currency }}</strong>
        </el-col>
        <el-col :sm="4" class="text-right">
          <el-button type="info" size="mini" icon="el-icon-download" @click="export_file_excel">Tải file Excel
          </el-button>
        </el-col>
      </el-row>

      <div id="double-scroll-wrapper-report" style="position: fixed; z-index: 2000; bottom: 0;">
        <div id="double-scroll-bar-report">
        </div>
      </div>

      <el-table id="main-table-report-fixed" :data="[]" :cell-class-name="m__cell_style"
                :header-cell-class-name="m__header_style">
        <el-table-column label="#" type="index" width="40px" header-align="center" fixed="left"></el-table-column>
        <!--        <el-table-column label="ID" prop="shop_id" width="110px" header-align="center"></el-table-column>-->
        <el-table-column :label="$t('base.shop')" prop="shop_name" width="200px" header-align="center"
                         show-tooltip-when-overflow fixed="left">
          <template slot-scope="scope">
            <a :href="`/agency-plan?shop=${scope.row._id}&file=${scope.row.file_id || ''}&month=${month}`"
               target="_blank">
              {{ scope.row.shop_name }}</a>
            <div style="font-size:10px; color:gray;">ID: {{ scope.row.shop_id }} -
              {{ scope.row.is_sub_account ? 'Shop phụ trách' : 'Shop đã thêm' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="File kế hoạch" prop="file_id" header-align="center" width="180px">
          <template slot-scope="scope">
            <el-select size="mini" value="" v-model="scope.row.file_id" :placeholder="$t('base.select_plan_file')"
                       filterable
                       @change="m__on_change_file(scope.row)">
              <el-option v-for="file of agency_files.filter(i => i.shopId === scope.row._id)" :key="file.id"
                         :value="file.id" :label="file.filename"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Kế hoạch" header-align="center" style="border-left: 2px solid">
          <el-table-column label="GMV" prop="target_gmv" width="120px" sortable="custom" style="border-left: 2px solid">
            <template slot-scope="scope">{{ scope.row.target_gmv | format_currency }}</template>
          </el-table-column>
          <el-table-column label="GMV Ads" prop="target_gmv" width="120px" sortable="custom"
                           style="border-left: 2px solid">
            <template slot-scope="scope">{{ scope.row.target_gmv_ads | format_currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('metric.ads_expense')" prop="target_cost" width="120px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.target_cost | format_currency }}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Thực tế" header-align="center">
          <el-table-column label="GMV" sortable="custom" width="120px" prop="current_gmv">
            <template slot-scope="scope">{{ scope.row.current_gmv | format_currency }}</template>
          </el-table-column>
          <el-table-column label="GMV Ads" sortable="custom" width="120px" prop="current_gmv_ads">
            <template slot-scope="scope">{{ scope.row.current_gmv_ads | format_currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('metric.ads_expense')" sortable="custom" width="120px" prop="current_cost">
            <template slot-scope="scope">{{ scope.row.current_cost | format_currency }}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="GMV còn thiếu" sortable="custom" width="120px" prop="remaining_gmv">
          <template slot-scope="scope">{{ scope.row.remaining_gmv | format_currency }}</template>
        </el-table-column>
        <el-table-column label="GMV dự kiến hoàn thành" sortable="custom" width="120px" prop="remaining_plan_gmv">
          <template slot-scope="scope">{{ scope.row.remaining_plan_gmv | format_currency }}</template>
        </el-table-column>
        <el-table-column label="GMV Ads còn thiếu" sortable="custom" width="120px" prop="remaining_gmv_ads">
          <template slot-scope="scope">{{ scope.row.remaining_gmv_ads | format_currency }}</template>
        </el-table-column>
        <el-table-column label="GMV Ads dự kiến hoàn thành" sortable="custom" width="120px"
                         prop="remaining_plan_gmv_ads">
          <template slot-scope="scope">{{ scope.row.remaining_plan_gmv_ads | format_currency }}</template>
        </el-table-column>
        <el-table-column label="Chi phí Ads còn lại" sortable="custom" width="120px" prop="remaining_cost">
          <template slot-scope="scope">
            <span v-if="+scope.row.remaining_cost > 0">
              {{ scope.row.remaining_cost | format_currency }}
            </span>
            <strong v-else class="text-danger">
              {{ scope.row.remaining_cost | format_currency }}
            </strong>
          </template>
        </el-table-column>
        <el-table-column :label="`TB / ngày còn lại (${m__get_remaining_day()} ngày)`" sortable="custom" width="120px"
                         prop="remaining_day">
          <template slot-scope="scope">
            {{ scope.row.remaining_day | format_currency }}
          </template>
        </el-table-column>
        <el-table-column label="Tỉ lệ hoàn thành GMV" sortable="custom" width="120px" prop="remaining_percent">
          <template slot-scope="scope">{{ scope.row.remaining_percent }} %</template>
        </el-table-column>
        <el-table-column label="Tỉ lệ hoàn thành GMV Ads" sortable="custom" width="120px" prop="remaining_percent">
          <template slot-scope="scope">{{ scope.row.remaining_percent_ads }} %</template>
        </el-table-column>
      </el-table>

      <el-table id="main-table-report" style="margin-top: 20px" :data="c__show_filter_data_list"
                v-loading="loading.get_data" @sort-change="m__sort_change"
                :cell-class-name="m__cell_style" :header-cell-class-name="m__header_style">
        <el-table-column label="#" type="index" width="40px" header-align="center" fixed="left"></el-table-column>
        <!--        <el-table-column label="ID" prop="shop_id" width="110px" header-align="center"></el-table-column>-->
        <el-table-column :label="$t('base.shop')" prop="shop_name" width="200px" header-align="center"
                         show-tooltip-when-overflow fixed="left">
          <template slot-scope="scope">
            <a :href="`/agency-plan?shop=${scope.row._id}&file=${scope.row.file_id || ''}&month=${month}`"
               target="_blank">
              {{ scope.row.shop_name }}</a>
            <div style="font-size:10px; color:gray;">ID: {{ scope.row.shop_id }} -
              {{ scope.row.is_sub_account ? 'Shop phụ trách' : 'Shop đã thêm' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="File kế hoạch" prop="file_id" header-align="center" width="180px">
          <template slot-scope="scope">
            <el-select size="mini" value="" v-model="scope.row.file_id" :placeholder="$t('base.select_plan_file')"
                       filterable
                       @change="m__on_change_file(scope.row)">
              <el-option v-for="file of agency_files.filter(i => i.shopId === scope.row._id)" :key="file.id"
                         :value="file.id" :label="file.filename"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Kế hoạch" header-align="center" style="border-left: 2px solid">
          <el-table-column label="GMV" prop="target_gmv" width="120px" sortable="custom" style="border-left: 2px solid">
            <template slot-scope="scope">{{ scope.row.target_gmv | format_currency }}</template>
          </el-table-column>
          <el-table-column label="GMV Ads" prop="target_gmv_ads" width="120px" sortable="custom"
                           style="border-left: 2px solid">
            <template slot-scope="scope">{{ scope.row.target_gmv_ads | format_currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('metric.ads_expense')" prop="target_cost" width="120px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.target_cost | format_currency }}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Thực tế" header-align="center">
          <el-table-column label="GMV" sortable="custom" width="120px" prop="current_gmv">
            <template slot-scope="scope">{{ scope.row.current_gmv | format_currency }}</template>
          </el-table-column>
          <el-table-column label="GMV Ads" sortable="custom" width="120px" prop="current_gmv_ads">
            <template slot-scope="scope">{{ scope.row.current_gmv_ads | format_currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('metric.ads_expense')" sortable="custom" width="120px" prop="current_cost">
            <template slot-scope="scope">{{ scope.row.current_cost | format_currency }}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="GMV còn thiếu" sortable="custom" width="120px" prop="remaining_gmv">
          <template slot-scope="scope">{{ scope.row.remaining_gmv | format_currency }}</template>
        </el-table-column>
        <el-table-column label="GMV dự kiến hoàn thành" sortable="custom" width="120px" prop="remaining_plan_gmv">
          <template slot-scope="scope">{{ scope.row.remaining_plan_gmv | format_currency }}</template>
        </el-table-column>
        <el-table-column label="GMV Ads còn thiếu" sortable="custom" width="120px" prop="remaining_gmv_ads">
          <template slot-scope="scope">{{ scope.row.remaining_gmv_ads | format_currency }}</template>
        </el-table-column>
        <el-table-column label="GMV Ads dự kiến hoàn thành" sortable="custom" width="120px"
                         prop="remaining_plan_gmv_ads">
          <template slot-scope="scope">{{ scope.row.remaining_plan_gmv_ads | format_currency }}</template>
        </el-table-column>
        <el-table-column label="Chi phí Ads còn lại" sortable="custom" width="120px" prop="remaining_cost">
          <template slot-scope="scope">
            <span v-if="+scope.row.remaining_cost > 0">
              {{ scope.row.remaining_cost | format_currency }}
            </span>
            <strong v-else class="text-danger">
              {{ scope.row.remaining_cost | format_currency }}
            </strong>
          </template>
        </el-table-column>
        <el-table-column :label="`TB / ngày còn lại (${m__get_remaining_day()} ngày)`" sortable="custom" width="120px"
                         prop="remaining_day">
          <template slot-scope="scope">
            {{ scope.row.remaining_day | format_currency }}
          </template>
        </el-table-column>
        <el-table-column label="Tỉ lệ hoàn thành GMV" sortable="custom" width="120px" prop="remaining_percent">
          <template slot-scope="scope">{{ scope.row.remaining_percent }} %</template>
        </el-table-column>
        <el-table-column label="Tỉ lệ hoàn thành GMV Ads" sortable="custom" width="120px" prop="remaining_percent">
          <template slot-scope="scope">{{ scope.row.remaining_percent_ads }} %</template>
        </el-table-column>
      </el-table>
      <div id="main-pagination-report"></div>
    </el-row>
  </div>
</template>

<script>
import {orderBy as _orderBy, uniqBy as _uniqBy} from 'lodash'
import {get_shop_mixins} from '../../mixins/get_shop';

export default {
  name: 'page__agency_report',

  mixins: [get_shop_mixins],

  data() {
    return {
      search: '',
      sort_option: {
        order: null,
        prop: null
      },
      agency_files: [],
      data: [],
      loading: {get_data: false},

      years: [],
      year: this.dayjs().year(),
      months: [],
      month: null,
      order_type: 'confirmed',
      interval: null,
      is_destroyed: false,
      completable: '',

      send_request_list: []
    }
  },

  async beforeMount() {
    this.loading.get_data = true

    this.years = []
    for (let i = this.dayjs().year(); i >= this.dayjs().year() - 2; i--) {
      this.years.push(i)
    }

    this.months = []
    const end_month = this.year >= this.dayjs().year() ? this.dayjs().month() + 1 : 12
    for (let i = 0; i < end_month; i++) {
      this.months.push(i)
    }
    this.month = this.dayjs().month()

    await this.m__get_shopee_shop()
    await this.m__send_request_list()
    await this.m__get_agency_file()
    await this.m__generate_data()
    this.loading.get_data = false
  },

  beforeDestroy() {
    this.is_destroyed = true
    clearInterval(this.interval)
    const dashboard_wrapper = document.getElementById('dashboard-wrapper')
    dashboard_wrapper.onscroll = () => {
    }
  },

  computed: {
    c__show_filter_data_list() {
      let result = this.data

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      if (this.completable) {
        if (this.completable === 'complete') {
          result = result.filter(i => +i.target_gmv <= +i.current_gmv)
        } else {
          result = result.filter(i => +i.target_gmv > +i.current_gmv)
        }
      }

      return result.filter(i => i.shop_id.includes(this.search) || i.shop_name.includes(this.search))
    }
  },

  methods: {
    async m__send_request_list() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/send_request_list', this.cf())
      this.send_request_list = resp.body.data
    },

    async export_file_excel() {
      if (!this.data || !this.data.length) {
        return
      }

      if (this.loading.get_data) {
        return
      }

      // const row = {
      //   index: index++,
      //   _id: shop._id,
      //   shop_id: shop.shop_id,
      //   shop_name: shop.username,
      //   file_id: agency_file_shop.body && agency_file_shop.body.agencyFileId && this.agency_files.find(i => i.id === agency_file_shop.body.agencyFileId) ? agency_file_shop.body.agencyFileId : '',
      //   is_sub_account: shop.is_sub_account,
      //   target_gmv: 0,
      //   target_cost: 0,
      //   target_gmv_ads: 0,
      //   current_gmv: 0,
      //   current_gmv_ads: 0,
      //   current_cost: 0,
      //   remaining_gmv: 0,
      //   remaining_plan_gmv: 0,
      //   remaining_gmv_ads: 0,
      //   remaining_plan_gmv_ads: 0,
      //   remaining_cost: 0,
      //   remaining_percent: 0,
      //   remaining_percent_ads: 0,
      //   remaining_day: 0
      // }

      const data = [
        ['ID', 'Cửa hàng', 'Kế hoạch', '', '', 'Thực tế', '', '', 'GMV còn thiếu', 'GMV dự kiến hoàn thành',
          'GMV Ads còn thiếu', 'GMV Ads dự kiến hoàn thành', 'Chi phí Ads còn lại', 'TB / ngày còn lại',
          'Tỉ lệ hoàn thành GMV', 'Tỉ lệ hoàn thành GVM Ads'],
        ['', '', 'GMV', 'GMV Ads', 'Chi phí Ads', 'GMV', 'GMV Ads', 'Chi phí Ads'],
        [],
        []
      ]

      for (const item of this.data) {
        const row = [item.shop_id, item.shop_name, item.target_gmv, item.target_gmv_ads, item.target_cost, item.current_gmv,
          item.current_gmv_ads, item.current_cost, item.remaining_gmv, item.remaining_plan_gmv, item.remaining_gmv_ads,
          item.remaining_plan_gmv_ads, item.remaining_cost, item.remaining_day, item.remaining_percent, item.remaining_percent_ads]
        data.push(row)
      }

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        data: data,
        filename: `file-bao-cao-tong-hop-${this.month + 1}-${this.year}.xlsx`
      }, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `file-bao-cao-tong-hop-${this.month + 1}-${this.year}.xlsx`)
      document.body.appendChild(link)
      link.click()
    },

    m__generate_scrollbar() {
      this.$nextTick(() => {
        try {
          const dashboard_wrapper = document.getElementById('dashboard-wrapper')
          const main_pagination = document.getElementById('main-pagination-report')

          const main_table = document.querySelector('div#main-table-report')
          const main_table_fixed = document.querySelector('div#main-table-report-fixed')
          const main_table_wrapper = document.querySelector('div#main-table-report div.el-table__body-wrapper')
          const main_table_wrapper_fixed = document.querySelector('div#main-table-report-fixed div.el-table__header-wrapper')
          const scrollbar = document.getElementById('double-scroll-bar-report')

          const scrollbar_wrapper = document.getElementById('double-scroll-wrapper-report')
          scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
          main_table_fixed.style.width = main_table.scrollWidth + 'px'

          scrollbar.appendChild(document.createElement('div'))
          scrollbar.style.overflow = 'auto'
          scrollbar.style.overflowY = 'hidden'
          scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          this.interval = setInterval(() => {
            scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
            main_table_fixed.style.width = main_table.scrollWidth + 'px'
            scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          }, 1000)
          scrollbar.firstChild.style.paddingTop = '1px'
          scrollbar.firstChild.appendChild(document.createTextNode('\xA0'))
          scrollbar.onscroll = () => {
            main_table_wrapper.scrollLeft = scrollbar.scrollLeft
            main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
          }
          main_table_wrapper.onscroll = () => {
            scrollbar.scrollLeft = main_table_wrapper.scrollLeft
            main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
          }

          const bounding_main_pagination = () => {
            const rect1 = main_pagination.getBoundingClientRect()
            const elem_top1 = rect1.top
            if (elem_top1 <= window.innerHeight) {
              scrollbar_wrapper.style.zIndex = '-1'
            } else {
              scrollbar_wrapper.style.zIndex = '2000'
            }

            const rect2 = main_table_wrapper.getBoundingClientRect()
            const elem_top2 = rect2.top
            // console.log(elem_top2)
            if (elem_top2 > 0) {
              main_table_fixed.style.zIndex = '-1'
            } else {
              main_table_fixed.style.zIndex = '2000'
            }
          }
          bounding_main_pagination()

          dashboard_wrapper.onscroll = () => {
            bounding_main_pagination()
          }
        } catch (e) {
        }
      })
    },

    m__header_style({column}) {
      if (['Kế hoạch', 'GMV', 'Thực tế', 'GMV còn thiếu'].includes(column.label)) {
        return 'cell-style'
      }
    },

    m__cell_style({column}) {
      if (['target_gmv', 'current_gmv', 'remaining_gmv'].includes(column.property)) {
        return 'cell-style'
      } else {
        return ''
      }
    },

    m__get_not_complete() {
      return this.data.filter(i => i.remaining_percent < 100).length
    },

    m__get_complete() {
      return this.data.filter(i => i.remaining_percent >= 100).length
    },

    m__get_out_of_cost() {
      return this.data.filter(i => i.current_cost > 0 && i.current_cost >= i.target_cost).length
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.sort_option.order = order
      this.sort_option.prop = prop
    },

    m__get_remaining_day() {
      if (this.dayjs().month() === this.month) {
        return this.dayjs().endOf('month').date() - this.dayjs().date()
      } else if (this.dayjs().month() > this.month) {
        return this.dayjs().endOf('month').date()
      }

      return 0
    },

    async m__get_agency_file() {
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/all', {
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file', {
      const mipeeUserIds = [this.$store.state.userInfo.username, ...this.send_request_list.filter(i => i.status === 'accepted').map(i => i.request_user.username)].join(',')
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/list', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          mipeeUserIds
        }
      })
      for (const item of resp.body) {
        item.loading = false
      }
      this.agency_files = resp.body.filter(i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : this.shopee_shop.list.some(ii => ii._id === i.shopId))
    },

    m__on_change_file(row) {
      const agency_file = this.agency_files.find(i => i.id === row.file_id)
      if (agency_file) {
        row.target_gmv = agency_file.expectedGmv
        row.target_gmv_ads = agency_file.expectedGmvAds
        row.target_cost = agency_file.expectedCost

        row.remaining_cost = row.target_cost - row.current_cost
        row.remaining_gmv = row.target_gmv - row.current_gmv
        row.remaining_plan_gmv = this.dayjs().month() === this.month ? Math.floor(row.current_gmv / this.dayjs().date() * this.dayjs().endOf('month').date()) : 0
        row.remaining_gmv_ads = row.target_gmv_ads - row.current_gmv_ads
        row.remaining_plan_gmv_ads = this.dayjs().month() === this.month ? Math.floor(row.current_gmv_ads / this.dayjs().date() * this.dayjs().endOf('month').date()) : 0
        row.remaining_percent = row.target_gmv > 0 ? +(row.current_gmv * 100 / row.target_gmv).toFixed(2) : 0
        row.remaining_percent_ads = row.target_gmv_ads > 0 ? +(row.current_gmv_ads * 100 / row.target_gmv_ads).toFixed(2) : 0

        if (row.remaining_gmv > 0) {
          if (this.dayjs().month() === this.month) {
            const remaining_day = this.dayjs().endOf('month').date() - this.dayjs().date() + 1
            row.remaining_day = Math.floor(row.remaining_gmv / remaining_day)
          } else if (this.dayjs().month() > this.month) {
            const remaining_day = this.dayjs().endOf('month').date()
            row.remaining_day = Math.floor(row.remaining_gmv / remaining_day)
          }
        }

        this.$http.post(this.API.URL_API_SRV_1 + '/agency_file/shop', {}, {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            shopId: row._id,
            month: this.month,
            year: this.year,
            agencyFileId: row.file_id
          }
        })
          .catch(console.error)
      }
    },

    async m__generate_data() {
      this.loading.get_data = true
      try {
        const shop_list = _uniqBy(this.shopee_shop.list, '_id')

        this.data = []
        let index = 1, data = []
        for (const shop of shop_list) {
          // if (shop.username !== 'tongkhosyhanoi') continue

          if (this.is_destroyed) return

          const agency_file_shop = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/shop', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              shopId: shop._id,
              month: this.month,
              year: this.year
            }
          })

          const row = {
            index: index++,
            _id: shop._id,
            shop_id: shop.shop_id,
            shop_name: shop.username,
            file_id: agency_file_shop.body && agency_file_shop.body.agencyFileId && this.agency_files.find(i => i.id === agency_file_shop.body.agencyFileId) ? agency_file_shop.body.agencyFileId : '',
            is_sub_account: shop.is_sub_account,
            target_gmv: 0,
            target_cost: 0,
            target_gmv_ads: 0,
            current_gmv: 0,
            current_gmv_ads: 0,
            current_cost: 0,
            remaining_gmv: 0,
            remaining_plan_gmv: 0,
            remaining_gmv_ads: 0,
            remaining_plan_gmv_ads: 0,
            remaining_cost: 0,
            remaining_percent: 0,
            remaining_percent_ads: 0,
            remaining_day: 0
          }

          if (!row.file_id && this.agency_files.filter(i => i.shopId === shop._id).length) {
            row.file_id = this.agency_files.filter(i => i.shopId === shop._id)[0].id
          }

          const agency_file = this.agency_files.find(i => i.id === row.file_id)
          if (agency_file) {
            row.target_gmv = agency_file.expectedGmv
            row.target_gmv_ads = agency_file.expectedGmvAds
            row.target_cost = agency_file.expectedCost
          }

          const start_time = this.dayjs([this.year, this.month]).startOf('month')
          const end_time = this.dayjs([this.year, this.month]).endOf('month').isBefore(this.dayjs(), 'day')
            ? this.dayjs([this.year, this.month]).endOf('month')
            : this.dayjs().endOf('day')

          const seller = await this.init_seller(shop)

          const end_time_clone = end_time.isSameOrAfter(this.dayjs(), 'd') ? this.dayjs().startOf('d') : end_time.clone().add(1, 'd').startOf('d')
          const metrics_resp = await seller.dashboard__key_metrics(start_time.unix(), end_time_clone.unix(), 'month')
          const key_metrics = metrics_resp.result

          if (!key_metrics) {
            continue
          }

          let place_gmv_key = 'place_gmv'
          if (this.order_type) place_gmv_key = place_gmv_key.replace(/(placed|place)/, this.order_type)
          row.current_gmv = key_metrics[place_gmv_key].value

          const resp = await seller.marketing_get_time_graph('new_cpc_homepage', start_time.unix(), end_time.unix(), {})
          if (resp && resp.data && resp.data.report_aggregate) {
            row.current_gmv_ads = Math.floor(resp.data.report_aggregate.broad_gmv / 100000)
            row.current_cost = Math.floor(resp.data.report_aggregate.cost / 100000)
          }

          row.remaining_cost = row.target_cost - row.current_cost
          row.remaining_gmv = row.target_gmv - row.current_gmv
          row.remaining_plan_gmv = this.dayjs().month() === this.month ? Math.floor(row.current_gmv / this.dayjs().date() * this.dayjs().endOf('month').date()) : 0
          row.remaining_gmv_ads = row.target_gmv_ads - row.current_gmv_ads
          row.remaining_plan_gmv_ads = this.dayjs().month() === this.month ? Math.floor(row.current_gmv_ads / this.dayjs().date() * this.dayjs().endOf('month').date()) : 0
          row.remaining_percent = row.target_gmv > 0 ? +(row.current_gmv * 100 / row.target_gmv).toFixed(2) : 0
          row.remaining_percent_ads = row.target_gmv_ads > 0 ? +(row.current_gmv_ads * 100 / row.target_gmv_ads).toFixed(2) : 0

          if (row.remaining_gmv > 0) {
            if (this.dayjs().month() === this.month) {
              const remaining_day = this.dayjs().endOf('month').date() - this.dayjs().date() + 1
              row.remaining_day = Math.floor(row.remaining_gmv / remaining_day)
            } else if (this.dayjs().month() > this.month) {
              const remaining_day = this.dayjs().endOf('month').date()
              row.remaining_day = Math.floor(row.remaining_gmv / remaining_day)
            }
          }

          data.push(row)
        }

        this.data = data
        this.m__generate_scrollbar()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_data = false
      }
    }
  }
}
</script>


[
['Mã Đơn', 'Tên KH', 'Địa chỉ'],
['1', 'A', 'A']
]



// WEBPACK FOOTER //
// src/pages/agency/report.vue